import cn from 'classnames'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../../../configs/translations'
import { setCockpitFilterMandatoryStatus } from '../../../../../../model'
import { selectCockpitFilterMandatoryStatus } from '../../../../../../model/selectors'
import type { TCockpitMandatoryStatus } from '../../../../../../model/types'
import { CockpitSegmentedControlAccent } from '../../../../../components/cockpitSegmentedControlAccent'

import styles from './CockpitMandatoryStatusFilter.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.mandatoryStatus

const MANDATORY_STATUS_OPTIONS: TCockpitMandatoryStatus[] = ['All', 'Mandatory', 'Non-Mandatory']

const renderTooltip = () => (
  <span className={styles.tooltip}>
    <Translation text={KEYS.tooltip} span />
  </span>
)

export const CockpitMandatoryStatusFilter = () => {
  const dispatch = useAppDispatch()
  const selectedStatus = useSelector(selectCockpitFilterMandatoryStatus)

  const handleSelect = useCallback(
    (status: TCockpitMandatoryStatus) => {
      dispatch(setCockpitFilterMandatoryStatus(status))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <span className={styles.label}>
        <Translation text={KEYS.label} span />
        <Tooltip tipContent={renderTooltip} textAlign="left" inline>
          <i className={cn('kbase kbase-question', styles.hintIcon)} aria-hidden="true" />
        </Tooltip>
      </span>
      <CockpitSegmentedControlAccent stretched>
        <SegmentedControl
          useItemKeys
          selectedItem={selectedStatus}
          onItemSelect={handleSelect}
          size="small"
          variant="veneer"
          isStreatched
        >
          {MANDATORY_STATUS_OPTIONS.map((status) => (
            <SegmentedControl.Item key={status} itemKey={status}>
              <Translation text={KEYS.options[status]} span />
            </SegmentedControl.Item>
          ))}
        </SegmentedControl>
      </CockpitSegmentedControlAccent>
    </div>
  )
}
